import { type FunctionComponent, } from "react";

export declare type ClaimrPointsProps = {
	// value in WEI
	value: number;
	loading?: boolean;
}

export const ClaimrPoints: FunctionComponent<ClaimrPointsProps> = ({
	value,
	loading = false,
}) => {
	const getValue = () => loading ? "loading..." : `${Intl.NumberFormat("en-us").format(Math.round(value))} [BARS]`;
	return <span className="currency-eth">{getValue()}</span>;
}
